import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

const SHORTCUTS = ["reset password", "spam", "sync", "passkey", "booking page"];

export const HeroSearch = ({ autoFocus = false, defaultValue = "" }) => {
  const [q, setQ] = useState(defaultValue);
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const term = q.trim();
    if (term) navigate(`/search?q=${encodeURIComponent(term)}`);
  };

  return (
    <div className="w-full max-w-2xl mx-auto">
      <form onSubmit={submit} className="relative">
        <Search className="absolute left-5 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 pointer-events-none" />
        <input
          data-testid="hero-search-input"
          autoFocus={autoFocus}
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search for help, e.g. reset password"
          className="w-full h-14 sm:h-16 pl-14 pr-28 rounded-full bg-white border border-slate-200/80 shadow-lg shadow-slate-900/5 text-base sm:text-lg text-slate-800 placeholder:text-slate-400 outline-none hover:border-blue-300 focus:border-[#1A73E8] focus:ring-4 focus:ring-blue-100 transition-all"
        />
        <button
          data-testid="hero-search-submit-btn"
          type="submit"
          className="absolute right-2 top-1/2 -translate-y-1/2 h-10 sm:h-12 px-5 sm:px-6 rounded-full bg-[#1A73E8] hover:bg-[#174EA6] text-white font-semibold text-sm transition-colors"
        >
          Search
        </button>
      </form>

      <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
        <span className="text-xs uppercase tracking-wider font-semibold text-slate-400 mr-1">
          Popular
        </span>
        {SHORTCUTS.map((s) => (
          <button
            key={s}
            data-testid="search-shortcut-chip"
            onClick={() => navigate(`/search?q=${encodeURIComponent(s)}`)}
            className="px-3.5 py-1.5 rounded-full bg-white border border-slate-200 text-sm text-slate-600 hover:border-[#1A73E8] hover:text-[#1A73E8] transition-colors"
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  );
};
